const STEPS = {
  TREATMENT: 'step_treatment_name',
  PATIENT_TYPE: 'step_patient_type_name',
  CLINIC: 'step_clinic_name',
  IDENTIFICATION: 'step_patient_identification_name',
  INSURANCE: 'step_insurance_name',
  APPOINTMENT: 'step_timeslot_selection_name',
  CONFIRMATION: 'step_confirmation_name',
}

export const getStepNameFromNumber = (stepNumber: number, isCityVariant: boolean, isAllClinicsVariant: boolean) => {
  const treatmentNames = (() => {
    if (isCityVariant || isAllClinicsVariant) {
      return {
        1: STEPS.TREATMENT,
        2: STEPS.CLINIC,
        3: STEPS.IDENTIFICATION,
        4: STEPS.APPOINTMENT,
        5: STEPS.CONFIRMATION,
      }
    }

    return {
      1: STEPS.TREATMENT,
      2: STEPS.IDENTIFICATION,
      3: STEPS.APPOINTMENT,
      4: STEPS.CONFIRMATION,
    }
  })() as Record<number, string>

  return treatmentNames[stepNumber]
}
